import { Component, OnInit } from '@angular/core';
import {
  AngularFireStorage,
  AngularFireUploadTask
} from '@angular/fire/storage';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable, VirtualTimeScheduler } from 'rxjs';
import { tap, finalize } from 'rxjs/operators';
import { LocalStorageService } from 'ngx-store';
import { AngularFireDatabase } from 'angularfire2/database';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'upload-page',
  templateUrl: './upload-page.component.html',
  styleUrls: ['./upload-page.component.css']
})
export class UploadPageComponent implements OnInit {
  // Main task
  task: AngularFireUploadTask;

  // Progress monitoring
  percentage: Observable<number>;

  snapshot: Observable<any>;

  // Download URL
  downloadURL: Observable<string>;

  // State for dropzone CSS toggling
  isHovering: boolean;
  uploadData;
  ImgPreviewList = [];
  docPreviewList = [];
  vidPreviewList = [];
  username;
  verify;
  themeRf;
  constructor(
    private storage: AngularFireStorage,
    private db: AngularFirestore,
    private ls: LocalStorageService,
    public afd: AngularFireDatabase,
    public santi: DomSanitizer
  ) { }

  ngOnInit() {
    this.username = this.ls.get('username');
    this.themeRf = this.afd.list("theme");
    this.getData();
    this.setTheme();
  }

  toggleHover(event: boolean) {
    this.isHovering = event;
  }

  startUpload(event: FileList) {
    // The File object
    const file = event.item(0);
    const fileType = file.type.split('/')[0];
    console.log(event, file.type.split('/')[0]);
    // Client-side validation example
    // if (file.type.split('/')[0]) {
    //   console.error('unsupported file type :( ');
    //   return;
    // }
    // The storage path
    const path = `test/${new Date().getTime()}_${file.name}`;

    // Totally optional metadata
    const customMetadata = { app: 'My AngularFire-powered PWA!' };

    // The main task
    this.task = this.storage.upload(path, file, { customMetadata });

    // Progress monitoring
    this.percentage = this.task.percentageChanges();
    this.snapshot = this.task.snapshotChanges().pipe(
      tap(snap => {
        if (snap.bytesTransferred === snap.totalBytes) {
          // Update firestore on completion
          this.db.collection('photos').add({ path, type: fileType, size: snap.totalBytes });
        }
      }),
      finalize(() => this.downloadURL = this.storage.ref(path).getDownloadURL())
    );


    // The file's download URL
  }

  getData() {
    // Totally optional metadata
    // The main task
    // var storageRef = this.db.collection('photos');
    const dev = false;
    if (dev) {
      var storageRef = this.db.collection('testSample');
    } else {
      var storageRef = this.db.collection('photos');
    }
    // Create a reference to the file we want to download
    storageRef.valueChanges().subscribe(data => {
      this.uploadData = data;
      if (data) {
        this.ImgPreviewList = [];
        this.vidPreviewList = [];
        data.forEach((ele) => {
          // const elePath = ele.path;
          console.log('ele', ele, ele['type'] == 'application');
          if (ele['type'] === "application") {
            this.storage.ref(ele['path']).getDownloadURL().subscribe((url) => {
              let safeUrl = this.santi.bypassSecurityTrustResourceUrl(url);
              this.docPreviewList.push({ safeUrl });
              console.log('docPreviewList', this.docPreviewList);
            });
          }
          if (ele['type'] == "image") {
            this.storage.ref(ele['path']).getDownloadURL().subscribe((url) => {
              this.ImgPreviewList.push({ url });
              console.log('ImgPreviewList', this.ImgPreviewList);
            });
          } else if (ele['type'] !== "application") {
            console.log('vidPreviewList', this.vidPreviewList);
            this.storage.ref(ele['path']).getDownloadURL().subscribe((url) => {
              this.vidPreviewList.push({ url });
              console.log('downloadURL', this.vidPreviewList);
            });
          }
        })
      }

    })

  }

  code() {
    const data = (<HTMLInputElement>document.getElementById("code")).value;
    if (data == "4200") {
      this.verify = true;
    } else {
      this.verify = false;
    }
    (<HTMLInputElement>document.getElementById("code")).value = "";
  }

  delelteAllMedia() {
    this.storage.ref('test').delete;
    var storageRef = this.db.collection('photos');
    // Create a reference to the file we want to download
    storageRef.valueChanges().subscribe(data => {
      this.uploadData = data;
      if (data) {
        this.ImgPreviewList = [];
        this.vidPreviewList = [];
        data.forEach((ele) => {
          this.storage.ref(ele['path']).delete();
        });
      }
    })
  }

  // Determines if the upload task is active
  isActive(snapshot) {
    return (
      snapshot.state === 'running' &&
      snapshot.bytesTransferred < snapshot.totalBytes
    );
  }

  setTheme() {
    this.themeRf.valueChanges().subscribe(theme => {
      console.log('theme', theme);
      if (theme.length > 0) {
        const newArr = theme.filter(val => {
          if (val.theme.name === this.ls.get('username')) {
            return val;
          }
        });
        console.log('test', newArr);
        if (!newArr[0]) {
          return;
        }
        if (newArr[0].theme.mode == 'light') {
          this.lightTheme();
          return;
        }
        if (newArr[0].theme.mode == 'dark') {
          this.darkTheme();
          return;
        }
      }
    });

  }


  darkTheme() {
    document.documentElement.style.setProperty('--p-header', '#524d5a');
    document.documentElement.style.setProperty('--p-header-txt', '#ffffff');
    document.documentElement.style.setProperty('--p-background', '#28262a');
    document.documentElement.style.setProperty('--p-txt-color', '#ffffff');
    document.documentElement.style.setProperty('--p-chat-txt-bg', '#524d5a');
    document.documentElement.style.setProperty('--p-chat-rx-txt-bg', '#78828e');
    document.documentElement.style.setProperty('--p-input-txt-clr', '#d6caca');
    document.documentElement.style.setProperty('--p-menu-txt-clr', '#ccc');
  }

  lightTheme() {
    document.documentElement.style.setProperty('--p-header', '#673ab7');
    document.documentElement.style.setProperty('--p-header-txt', '#ffffff');
    document.documentElement.style.setProperty('--p-background', '#28262a');
    document.documentElement.style.setProperty('--p-txt-color', '#ffffff');
    document.documentElement.style.setProperty('--p-chat-txt-bg', '#673ab7');
    document.documentElement.style.setProperty('--p-chat-rx-txt-bg', '#6c757d');
    document.documentElement.style.setProperty('--p-input-txt-clr', '#ccc');
    document.documentElement.style.setProperty('--p-menu-txt-clr', '#c5c4c4');
  }
}
